export default __webpack_public_path__ + "images/models/f79e51e1f71cc261bcd7227e4bc6ffc9.glb";